import styles from './Calculator.module.scss';
import {useTranslation} from "react-i18next";

const ResultPanel: React.FC<{ result: any, warnings: string[] }> = ({result, warnings}) => {

  const { t } = useTranslation();
  const whole = Math.floor(result / 7);
  const remainder = Math.floor(result) % 7;
  const unwanted = whole > 5;
  const texts = [...warnings];

  if (unwanted) {
    texts.unshift(t("warnings.overLimit"))
  }
  if (!result) return null;
  return (
    <div className={`${styles['result-panel']}`}>
      <h4>{t("cleansed")}:</h4>
      <div className={`${styles['results']} ${texts.length && styles['unwanted']}`}>
        {whole} <span>{remainder}/7</span>
      </div>
      {!!texts.length && <div className={`${styles['description']}`}>
        {texts.map((text: string) => <div>{text}</div>)}
      </div>}
    </div>
  );
};

export default ResultPanel;